
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ExternalLink } from "lucide-react";
import Image from "@/components/ui/image";

interface IntegrationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onXeroIntegration: () => void;
  onMyobIntegration: () => void;
}

const IntegrationDialog: React.FC<IntegrationDialogProps> = ({
  open,
  onOpenChange,
  onXeroIntegration,
  onMyobIntegration,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Choose Accounting System</DialogTitle>
          <DialogDescription>
            Select the accounting system you want to integrate with
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Xero Card */}
            <Card className="cursor-pointer hover:border-primary transition-colors" onClick={onXeroIntegration}>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg">Xero</CardTitle>
                <CardDescription>
                  Connect to Xero accounting software
                </CardDescription>
              </CardHeader>
              <CardContent className="flex justify-center pt-2">
                <img 
                  src="/lovable-uploads/7f6c3b34-d06f-4167-83e6-b377d2f426d3.png" 
                  alt="Xero Logo" 
                  className="h-14 object-contain" 
                />
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="outline" size="sm" className="w-full">
                  Connect <ExternalLink className="ml-2 h-3 w-3" />
                </Button>
              </CardFooter>
            </Card>

            {/* MYOB Card */}
            <Card className="cursor-pointer hover:border-primary transition-colors" onClick={onMyobIntegration}>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg">MYOB</CardTitle>
                <CardDescription>
                  Connect to MYOB accounting software
                </CardDescription>
              </CardHeader>
              <CardContent className="flex justify-center pt-2">
                <img 
                  src="/lovable-uploads/36c4e1d9-acf1-4884-aa4b-a1c2c9f3edfb.png" 
                  alt="MYOB Logo" 
                  className="h-14 object-contain" 
                />
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="outline" size="sm" className="w-full">
                  Connect <ExternalLink className="ml-2 h-3 w-3" />
                </Button>
              </CardFooter>
            </Card>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default IntegrationDialog;
